import Home from "@/views/Home.vue"
import NotFound from "@/views/NotFound.vue"
import Forbidden from "@/views/Forbidden.vue"
import Contact from "@/views/Contact.vue"
import Pages from "@/views/Pages.vue"
import ProjectCategory from "@/views/ProjectCategory.vue"
import ProjectDetail from "@/views/ProjectDetail.vue"

export const appRoutes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'routes.titles.home',
            description: 'routes.descriptions.home',
            requiresAuth: false
        }
    },
    {
        path: '/403',
        name: 'forbidden',
        component: Forbidden,
        meta: {
            title: 'routes.titles.forbidden',
            description: 'routes.descriptions.forbidden',
            requiresAuth: false
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: {
            title: 'routes.titles.contact',
            description: 'routes.descriptions.contact',
            requiresAuth: false
        }
    },
    {
        path: '/pages/:slug',
        name: 'pages',
        component: Pages,
        meta: {
            title: 'routes.titles.pages',
            description: 'routes.descriptions.pages',
            requiresAuth: false
        }
    },
    {
        path: '/projects/:categorySlug',
        name: 'project-category',
        component: ProjectCategory,
        meta: {
            title: 'routes.titles.project_category',
            description: 'routes.descriptions.project_category',
            requiresAuth: false
        }
    },
    {
        path: '/projects/:categorySlug/:projectSlug',
        name: 'project-detail',
        component: ProjectDetail,
        meta: {
            title: 'routes.titles.project_detail',
            description: 'routes.descriptions.project_detail',
            requiresAuth: false
        }
    },
    // Catch-all route - MUST be last to avoid intercepting other routes
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound,
        meta: {
            title: 'routes.titles.not_found',
            description: 'routes.descriptions.not_found',
            requiresAuth: false
        }
    }
]
